import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { unwrapResult } from '@reduxjs/toolkit'
import { ENTITY_TYPES } from '@sales-center/common'
import { ICrossBranchReassign } from '../typings'
import { getCrossBranchReassign } from '../api'

export const useGetCrossBranchValidation = (
  entityId: number,
  entityType: ENTITY_TYPES,
) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )
  const [crossBranchValidation, setCrossBranchValidation] =
    useState<ICrossBranchReassign>()

  useEffect(() => {
    const execute = async () => {
      try {
        setStatus('pending')

        if (!!entityId && entityType === ENTITY_TYPES.Lead) {
          const result = await dispatch(getCrossBranchReassign(entityId))

          if (getCrossBranchReassign.fulfilled.match(result)) {
            setCrossBranchValidation(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        } else {
          setCrossBranchValidation(undefined)
          setStatus('success')
        }
      } catch (error) {
        setStatus('fail')
        // Handle or log the error here
      }
    }

    execute()
  }, [dispatch, entityId, entityType])

  return { crossBranchValidationStatus: status, crossBranchValidation }
}
